const ERROR_TEXT_INVALID_FIELD_PREFIX = 'invalid_';

const isNonEmptyFieldValue = (value) => value !== null && value !== undefined && String(value).trim() !== '';

const getInvalidFieldErrorText = (field) => `${ERROR_TEXT_INVALID_FIELD_PREFIX}${field}`;

// A field counts once its error becomes visible; the ELAL contract excludes empty required fields.
// A blur that clears and re-shows the error for the same value is still one occurrence.
const getNewlyInvalidFields = (fields = [], reportedValues = {}) =>
    fields
        .filter(
            ({ name, wasValid, isValid, value }) =>
                wasValid && !isValid && isNonEmptyFieldValue(value) && reportedValues[name] !== value,
        )
        .map(({ name }) => name);

const forgetResolvedInvalidValues = (fields = [], reportedValues = {}) =>
    fields.reduce((remaining, { name, isValid, value }) => {
        if (isValid && name in remaining && remaining[name] !== value) {
            const { [name]: _resolved, ...rest } = remaining;
            return rest;
        }
        return remaining;
    }, reportedValues);

module.exports = {
    isNonEmptyFieldValue,
    getInvalidFieldErrorText,
    getNewlyInvalidFields,
    forgetResolvedInvalidValues,
};
